import { MATRIX_BACKEND } from '@/remotes';
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';

export async function useCheckAvailablePickedTime(validateCounterparties) {
  const dataForm = useNewDataFormCargoPickUpStore();

  const { cargoInformation } = dataForm;

  const body = {};
  const city = dataForm.sender.cityFrom;

  const weight = Number(cargoInformation.cargoWeight);

  if (!city || !dataForm.sender.pickUpDate || !dataForm.sender.cargoTimePickup) {
    return;
  }
  const { id: cargoTypeId } = dataForm.cargoInformation.typeOfCargo;

  body['cityId'] = city.id;
  body['cargoType'] = cargoTypeId;

  const cargoDimensions = cargoInformation.cargoDimensions;
  const sizeOfCargoCylinder = dataForm.cargoInformation.sizeOfCargoCylinder;

  switch (cargoTypeId) {
    case 1:
      if (dataForm.getIsValidStandard) {
        body['weight'] = weight;

        body['length'] = Number(cargoDimensions.length);
        body['width'] = Number(cargoDimensions.width);
        body['height'] = Number(cargoDimensions.height);
        body['period'] = dataForm.sender.cargoTimePickup;
      } else {
        validateCounterparties();
        dataForm.sender.pickUpDate = '';
        dataForm.sender.cargoTimePickup = '';
        return;
      }
      break;
    case 2:
      if (dataForm.getIsValidCylinder) {
        body['weight'] = weight;

        body['height'] = Number(sizeOfCargoCylinder.height);
        body['diameter'] = Number(sizeOfCargoCylinder.diameter);
        body['period'] = dataForm.sender.cargoTimePickup;
      } else {
        validateCounterparties();
        dataForm.sender.pickUpDate = '';
        dataForm.sender.cargoTimePickup = '';
        return;
      }
      break;

    default:
      break;
  }

  try {
    // #TODO
    const status = (await MATRIX_BACKEND.post('/api/public/check-pick-up-time', body)).status;
    if (status !== 204) {
      dataForm.sender.pickUpDate = '';
      dataForm.sender.cargoTimePickup = '';
      validateCounterparties();
    }
  } catch {
    dataForm.sender.pickUpDate = '';
    dataForm.sender.cargoTimePickup = '';
    validateCounterparties();
  }
}
